import axios from "axios";

export const getStatesByCountry = async (country) => {
    const response = await axios.post(
        "https://countriesnow.space/api/v0.1/countries/states",
        { country },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

export const fetchCountriesData = async () => {
    try {
        const res = await axios.post('https://countriesnow.space/api/v0.1/countries/cities', {
            "iso2": "IN"
        });
        console.log("objectnewwwww", res)
        return res
    } catch (error) {
        console.log("errror of cities api")
        return error | "Internal Server Error"
    }
};

export const getAllCountries = async () => {
    const response = await axios.get("https://countriesnow.space/api/v0.1/countries");
    return response.data;
};

export const getCitiesByState = async (country, state) => {
    const response = await fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ country, state }),
    });

    const data = await response.json();
    return data?.data || [];
};